import React from 'react';
import { useNavigate } from 'react-router';
import { Button, notification, Typography } from 'antd';
import { Link } from 'react-router-dom';

import { useQuery } from 'hooks/useQuery';
import { useAppDispatch, useAppSelector } from 'store';
import {
  deleteSignedAgreement,
  loadSignedAgreementsList,
  setUnPublishSignedAgreement,
} from 'store/slices/signedAgreements/actions';
import {
  QueryFormValues,
  SignedAgreementsItem,
} from 'store/slices/signedAgreements/interfaces';
import { useDeepEffect } from 'utils/useDeepEffect';
import { MainLayout } from 'components/Layout/MainLayout';
import { canBeUnPublished } from 'utils/rights';
import { PageTitles } from 'constants/pageTitles';
import { StickyConfirmModal } from 'components/modals/StickyConfirmModal';
import { StatusesEnum } from 'constants/status';

import { TableAgreements } from './components/TableAgreements';
import { Filters } from './components/Filters';

export const List = () => {
  const query = useQuery();
  const [sort, setSort] = React.useState<string | undefined>('');
  const [isRemoveModalIsOpen, setRemoveModalIsOpen] =
    React.useState<boolean>(false);
  const [currentItem, setCurrentItem] = React.useState(null);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { list, total, limit } = useAppSelector(
    state => state.signedAgreements
  );

  const onCreateClick = () => navigate('add');

  const onRemoveModalClose = () => setRemoveModalIsOpen(false);

  const loadItems = () =>
    dispatch(loadSignedAgreementsList({ ...(query as QueryFormValues), sort }));

  const onRemoveClick = async () => {
    await dispatch(deleteSignedAgreement({ id: currentItem.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно удалена',
        });
        loadItems();
        onRemoveModalClose();
      });
  };

  const handleUnPublish = async (id: number) => {
    await dispatch(setUnPublishSignedAgreement(id))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно снята с публикации',
        });
        loadItems();
      });
  };

  useDeepEffect(() => {
    loadItems();
  }, [query, sort]);

  const buttonList = [
    <Button key={1} onClick={onCreateClick} type='primary'>
      Создать
    </Button>,
  ];

  const getActions = (item: SignedAgreementsItem) => [
    {
      key: 'edit',
      label: (
        <Link to={`/signedAgreements/${item.id}/edit`}>Редактировать</Link>
      ),
    },
    {
      key: 'unPublish',
      label: <Typography.Text>Снять с публикации</Typography.Text>,
      onClick: () => handleUnPublish(item?.id || 0),
      disabled: !canBeUnPublished(item),
    },
    {
      key: 'remove',
      label: 'Удалить',
      danger: true,
      onClick: () => {
        if (item.status === StatusesEnum.PUBLISHED) {
          notification.error({
            message: 'Необходимо снять сущность с публикации',
          });
        } else {
          setRemoveModalIsOpen(true);
          setCurrentItem(item);
        }
      },
    },
  ];

  return (
    <MainLayout
      aside={<Filters />}
      pageTitle={PageTitles['signedAgreements']}
      extraButtonsList={buttonList}
    >
      <TableAgreements
        items={list}
        setSort={setSort}
        total={total}
        limit={limit}
        getActions={getActions}
      />
      <StickyConfirmModal
        isOpen={isRemoveModalIsOpen}
        onRequestClose={onRemoveModalClose}
        title='Удаление сущности'
        okText='Удалить'
        text='Вы действительно хотите удалить эту cущность?'
        onSubmit={onRemoveClick}
        okButtonProps={{ danger: true }}
      />
    </MainLayout>
  );
};
